import React from "react";
import Filter from "./Filter";
import AppetiteProduct from "./AppetiteProduct";
import Resources from "./Resources";
import Geolocator from "./Geolocator";
import AppetiteAccordion from "./AppetiteAccordion";

class MainProducts extends React.Component {
    render() {
        const {
            isGuideOpen,
            isFilterOpen,
            toggleFilter,
            isAppetiteAccordionOpen,
            toggleAppetiteAccordion,
            isResourcesAccordionOpen,
            toggleResourcesAccordion,
        } = this.props;

        return (
            <main
                role="main"
                className={`main ${isGuideOpen ? "main--blur" : ""}`}
            >
                <Filter
                    isFilterOpen={isFilterOpen}
                    toggleFilter={toggleFilter}
                    isAppetiteAccordionOpen={isAppetiteAccordionOpen}
                    toggleAppetiteAccordion={toggleAppetiteAccordion}
                />
                <AppetiteAccordion
                    isAppetiteAccordionOpen={isAppetiteAccordionOpen}
                    toggleAppetiteAccordion={toggleAppetiteAccordion}
                >
                    <AppetiteProduct {...this.props} />
                </AppetiteAccordion>
                <Resources
                    {...this.props}
                    isResourcesAccordionOpen={
                        isResourcesAccordionOpen
                    }
                    toggleResourcesAccordion={
                        toggleResourcesAccordion
                    }
                />
                <Geolocator {...this.props} />
            </main>
        );
    }
}

export default MainProducts;



// WEBPACK FOOTER //
// ./src/components/MainProducts.js